import { Alert02Icon, CheckmarkBadge02Icon } from '@hugeicons-pro/core-solid-rounded';
import { HugeiconsIcon } from '@hugeicons/react';
import cn from 'classnames';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import styles from './VerificationBadge.module.scss';

const typeIconClass = {
  success: 'text-green-2',
  warning: 'text-orange-3',
  attention: 'text-orange-3',
  critical: 'text-red-3',
};

export const VerificationBadge = ({ type = 'success', tip = '', className = '', onClick }) => {
  return (
    <OverlayTrigger
      trigger={tip ? ['hover', 'focus'] : 'none'}
      placement="bottom"
      overlay={<Tooltip>{tip}</Tooltip>}>
      <div
        className={cn(styles.root, styles[`root--${type}`], {
          [className]: className,
          'u-pointer': onClick,
        })}
        onClick={() => (onClick ? onClick() : null)}>
        <HugeiconsIcon
          size={20}
          icon={type === 'success' ? CheckmarkBadge02Icon : Alert02Icon}
          className={typeIconClass[type] || typeIconClass.attention}
        />
      </div>
    </OverlayTrigger>
  );
};
